"use client";

import React, { useEffect, useState } from "react";
import Logging from "@/utils/Logging";
import { ISbStoryData } from "storyblok-js-client";

import styles from "./TermsOfServiceContent.module.scss";
import RichText from "@/components/Richtext";

const TermsOfServiceContent = () => {
  const [storyBlokData, setStoryBlokData] = useState<ISbStoryData>();

  useEffect(() => {
    const loadStoryBlokData = async () => {
      const { story } = await fetchData();

      setStoryBlokData(story);
    };

    loadStoryBlokData();
  }, []);

  const content = storyBlokData?.content;
  const { header, lastUpdated, textContent } = content || {};

  return (
    <div className={styles.wrapper}>
      <div className={styles.content}>
        <h1>{header}</h1>
        <p>Last updated: {lastUpdated}</p>

        <div className={styles.contentWrapper}>
          <section className={styles.textSection}>
            <RichText>{textContent}</RichText>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsOfServiceContent;

const fetchData = async () => {
  const version =
    process.env.NODE_ENV === "development" ? "draft" : "published";

  try {
    const response = await fetch(
      `https://api-us.storyblok.com/v2/cdn/stories/hibt-v1-1/hibt-terms-of-service?version=${version}&token=${process.env.NEXT_PUBLIC_STORYBLOK_API_KEY}`
    );

    const data = await response.json();

    return data;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    Logging.networkError("Storyblok Error - PrivacyPageContent", {
      pageName: "Privacy page",
      errorMessage: error.message,
      errorCode: error.code,
      statusCode: error.response?.status,
    });
  }
};
